function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  "data-name": "Path 77",
  d: "M138.681,430.233H136.41v-6.963A2.27,2.27,0,0,0,134.14,421H97.812a2.27,2.27,0,0,0-2.271,2.271v6.963H93.271a2.271,2.271,0,0,0,0,4.541h45.41a2.271,2.271,0,0,0,0-4.541Zm0,0",
  transform: "translate(-77.226 -357.274)",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M70.689,0H6.812A6.819,6.819,0,0,0,0,6.812V10.27a24.765,24.765,0,0,0,16.94,23.5l2.41.8A22.624,22.624,0,0,0,31.787,44.3v3.531A2.273,2.273,0,0,1,29.517,50.1a6.819,6.819,0,0,0-6.812,6.812v2.271h32.09V56.914A6.819,6.819,0,0,0,47.983,50.1a2.273,2.273,0,0,1-2.271-2.271V44.3A22.627,22.627,0,0,0,58.15,34.576l2.41-.8A24.765,24.765,0,0,0,77.5,10.27V6.812A6.819,6.819,0,0,0,70.689,0ZM8.976,22.909A20.3,20.3,0,0,1,4.541,10.271V6.812A2.273,2.273,0,0,1,6.812,4.541h7.049l2.312,20.8a22.257,22.257,0,0,0,.692,3.5,20.152,20.152,0,0,1-7.89-5.929ZM49.4,19.441l-3.659,3.481.86,4.9a2.269,2.269,0,0,1-3.273,2.412l-4.577-2.35-4.577,2.35A2.269,2.269,0,0,1,30.9,27.827l.86-4.9L28.1,19.441a2.27,2.27,0,0,1,1.246-3.894l5.1-.725,2.271-4.494a2.364,2.364,0,0,1,4.053,0l2.271,4.494,5.1.725A2.27,2.27,0,0,1,49.4,19.441Zm23.561-9.171A20.06,20.06,0,0,1,60.634,28.838a22.256,22.256,0,0,0,.692-3.5l2.312-20.8h7.049a2.273,2.273,0,0,1,2.271,2.271Zm0,0",
  fill: "#707070"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  d: "M233.685,109.8l-.78-1.543-.78,1.543a2.269,2.269,0,0,1-1.707,1.224l-1.632.231,1.144,1.089a2.271,2.271,0,0,1,.669,2.038l-.279,1.6,1.547-.8a2.281,2.281,0,0,1,2.075,0l1.548.8-.28-1.6a2.271,2.271,0,0,1,.67-2.038l1.144-1.089-1.632-.231A2.269,2.269,0,0,1,233.685,109.8Zm0,0",
  transform: "translate(-194.154 -91.868)",
  fill: "#707070"
});

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marketing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.5,
    height: 77.5,
    viewBox: "0 0 77.5 77.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.7b9fa125.svg";
export { ForwardRef as ReactComponent };